import { defineComponent as ia, useAttrs as da, useSlots as ca, inject as Ve, toRef as va, ref as $, computed as f, watch as ne, openBlock as V, createElementBlock as E, normalizeClass as i, unref as t, createElementVNode as b, renderSlot as K, Fragment as ma, renderList as fa, toDisplayString as U, createCommentVNode as P, createVNode as D, withDirectives as I, withCtx as R, vShow as B, withKeys as ge, createBlock as x, createTextVNode as Ce, nextTick as se } from "vue";
import y from "./index592.js";
import { ElButton as Te } from "./index536.js";
import { ElInput as Fe } from "./index545.js";
import { ElIcon as G } from "./index538.js";
import { DArrowLeft as pa, ArrowLeft as ha, ArrowRight as ba, DArrowRight as ya } from "./index537.js";
import { panelDatePickProps as ka } from "./index861.js";
import { correctlyParseUserInput as _e, getValidDateOfYear as $e, getValidDateOfMonth as Ee } from "./index862.js";
import { ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY as wa } from "./index632.js";
import Da from "./index863.js";
import Va from "./index864.js";
import ga from "./index865.js";
import { PICKER_BASE_INJECTION_KEY as Ca, DEFAULT_FORMATS_TIME as Ta, DEFAULT_FORMATS_DATE as Fa } from "./index579.js";
import { extractTimeFormat as _a, extractDateFormat as $a } from "./index578.js";
import { extractFirst as L } from "./index765.js";
import Ea from "./index591.js";
import Pa from "./index598.js";
import { useNamespace as Pe } from "./index559.js";
import { useLocale as Ma } from "./index597.js";
import { useFormDisabled as Na } from "./index586.js";
import { isArray as ue, isFunction as Me } from "./index575.js";
import { getEventCode as Ia } from "./index589.js";
import { EVENT_CODE as k } from "./index590.js";
const Ra = ["disabled", "onClick"], Aa = ["aria-label", "disabled"], Ya = ["aria-label", "disabled"], Oa = ["tabindex", "aria-disabled"], Sa = ["tabindex", "aria-disabled"], Ka = ["aria-label", "disabled"], Ua = ["aria-label", "disabled"];
var dt = /* @__PURE__ */ ia({
  __name: "panel-date-pick",
  props: ka,
  emits: ["pick", "set-picker-option", "panel-change"],
  setup(Ne, { emit: Ie }) {
    const Re = (e, a, o) => !0, n = Ne, F = Ie, p = Pe("picker-panel"), g = Pe("date-picker"), Ae = da(), Ye = ca(), { t: C, lang: v } = Ma(), ie = Ve(Ca), de = Ve(
      wa,
      void 0
    ), { shortcuts: ce, disabledDate: d, cellClassName: Q, defaultTime: X } = ie.props, A = va(ie.props, "defaultValue"), z = $(), l = $(y().locale(v.value)), Z = $(!1);
    let ee = !1;
    const ve = f(() => y(X).locale(v.value)), Oe = f(() => l.value.month()), me = f(() => l.value.year()), fe = $([]), M = $(null), N = $(null), ae = (e) => fe.value.length > 0 ? Re(e, fe.value, n.format || "HH:mm:ss") : !0, pe = (e) => X && !we.value && !Z.value && !ee ? ve.value.year(e.year()).month(e.month()).date(e.date()) : Y.value ? e.millisecond(0) : e.startOf("day"), m = (e, ...a) => {
      if (!e)
        F("pick", e, ...a);
      else if (ue(e)) {
        const o = e.map(pe);
        F("pick", o, ...a);
      } else
        F("pick", pe(e), ...a);
      M.value = null, N.value = null, Z.value = !1, ee = !1;
    }, Se = async (e, a) => {
      if (u.value === "date" && y.isDayjs(e)) {
        const o = L(n.parsedValue);
        let c = o ? o.year(e.year()).month(e.month()).date(e.date()) : e;
        ae(c), l.value = c, m(c, Y.value || a);
      } else u.value === "week" ? m(e.date) : u.value === "dates" && m(e, !0);
    }, he = (e) => {
      const a = e ? "add" : "subtract";
      l.value = l.value[a](1, "month"), j("month");
    }, be = (e) => {
      const a = l.value, o = e ? "add" : "subtract";
      l.value = s.value === "year" ? a[o](10, "year") : a[o](1, "year"), j("year");
    }, s = $("date"), Ke = f(() => {
      const e = C("el.datepicker.year");
      if (s.value === "year") {
        const a = Math.floor(me.value / 10) * 10;
        return e ? `${a} ${e} - ${a + 9} ${e}` : `${a} - ${a + 9}`;
      }
      return `${me.value} ${e}`;
    }), Ue = (e) => {
      const a = Me(e.value) ? e.value() : e.value;
      if (a) {
        ee = !0, m(y(a).locale(v.value));
        return;
      }
      e.onClick && e.onClick({
        attrs: Ae,
        slots: Ye,
        emit: F
      });
    }, u = f(() => {
      const { type: e } = n;
      return ["week", "month", "months", "year", "years", "dates"].includes(e) ? e : "date";
    }), W = f(() => u.value === "dates" || u.value === "months" || u.value === "years"), Be = f(() => u.value === "date" ? s.value : u.value), ye = f(() => !!ce.length), Le = async (e, a) => {
      u.value === "month" ? (l.value = Ee(
        l.value,
        l.value.year(),
        e,
        v.value,
        d
      ), m(l.value, !1)) : u.value === "months" ? m(e, a ?? !0) : (l.value = Ee(
        l.value,
        l.value.year(),
        e,
        v.value,
        d
      ), s.value = "date", ["month", "year", "date", "week"].includes(u.value) && (m(l.value, !0), await se(), J())), j("month");
    }, ze = async (e, a) => {
      if (u.value === "year") {
        const o = l.value.startOf("year").year(e);
        l.value = $e(o, v.value, d), m(l.value, !1);
      } else if (u.value === "years")
        m(e, a ?? !0);
      else {
        const o = l.value.year(e);
        l.value = $e(o, v.value, d), s.value = "month", ["month", "year", "date", "week"].includes(u.value) && (m(l.value, !0), await se(), J());
      }
      j("year");
    }, w = Na(), H = async (e) => {
      w.value || (s.value = e, await se(), J());
    }, Y = f(
      () => n.type === "datetime" || n.type === "datetimerange"
    ), We = f(() => {
      const e = Y.value || u.value === "dates", a = u.value === "years", o = u.value === "months", c = s.value === "date", h = s.value === "year", _ = s.value === "month";
      return e && c || a && h || o && _;
    }), He = f(
      () => !W.value && n.showNow || n.showConfirm
    ), Je = f(() => d ? n.parsedValue ? ue(n.parsedValue) ? d(n.parsedValue[0].toDate()) : d(n.parsedValue.toDate()) : !0 : !1), je = () => {
      if (W.value)
        m(n.parsedValue);
      else {
        let e = L(n.parsedValue);
        if (!e) {
          const a = y(X).locale(v.value), o = oe();
          e = a.year(o.year()).month(o.month()).date(o.date());
        }
        l.value = e, m(e);
      }
    }, qe = f(() => d ? d(y().locale(v.value).toDate()) : !1), xe = () => {
      const a = y().locale(v.value).toDate();
      Z.value = !0, (!d || !d(a)) && ae(a) && (l.value = y().locale(v.value), m(l.value));
    }, te = f(() => n.timeFormat || _a(n.format) || Ta), ke = f(() => n.dateFormat || $a(n.format) || Fa), we = f(() => N.value ? N.value : !n.parsedValue && !A.value ? void 0 : (L(n.parsedValue) || l.value).format(te.value)), Ge = f(() => M.value ? M.value : !n.parsedValue && !A.value ? void 0 : (L(n.parsedValue) || l.value).format(ke.value)), O = $(!1), Qe = () => {
      O.value = !0;
    }, Xe = () => {
      O.value = !1;
    }, le = (e) => ({
      hour: e.hour(),
      minute: e.minute(),
      second: e.second(),
      year: e.year(),
      month: e.month(),
      date: e.date()
    }), Ze = (e, a, o) => {
      const { hour: c, minute: h, second: _ } = le(e), q = L(n.parsedValue), re = q ? q.hour(c).minute(h).second(_) : e;
      l.value = re, m(l.value, !0), o || (O.value = a);
    }, ea = (e) => {
      const a = y(e, te.value).locale(v.value);
      if (a.isValid() && ae(a)) {
        const { year: o, month: c, date: h } = le(l.value);
        l.value = a.year(o).month(c).date(h), N.value = null, O.value = !1, m(l.value, !0);
      }
    }, aa = (e) => {
      const a = _e(
        e,
        ke.value,
        v.value,
        de
      );
      if (a.isValid()) {
        if (d && d(a.toDate()))
          return;
        const { hour: o, minute: c, second: h } = le(l.value);
        l.value = a.hour(o).minute(c).second(h), M.value = null, m(l.value, !0);
      }
    }, ta = (e) => y.isDayjs(e) && e.isValid() && (d ? !d(e.toDate()) : !0), la = (e) => _e(
      e,
      n.format,
      v.value,
      de
    ), oe = () => {
      const e = y(A.value).locale(v.value);
      if (!A.value) {
        const a = ve.value;
        return y().hour(a.hour()).minute(a.minute()).second(a.second()).locale(v.value);
      }
      return e;
    }, J = () => {
      var e;
      ["week", "month", "year", "date"].includes(u.value) && ((e = z.value) == null || e.focus());
    }, oa = () => {
      J(), u.value === "week" && De(k.down);
    }, ra = (e) => {
      const a = Ia(e);
      [
        k.up,
        k.down,
        k.left,
        k.right,
        k.home,
        k.end,
        k.pageUp,
        k.pageDown
      ].includes(a) && (De(a), e.stopPropagation(), e.preventDefault()), [k.enter, k.space, k.numpadEnter].includes(
        a
      ) && M.value === null && N.value === null && (e.preventDefault(), m(l.value, !1));
    }, De = (e) => {
      var a;
      const { up: o, down: c, left: h, right: _, home: q, end: re, pageUp: na, pageDown: sa } = k, ua = {
        year: {
          [o]: -4,
          [c]: 4,
          [h]: -1,
          [_]: 1,
          offset: (r, T) => r.setFullYear(r.getFullYear() + T)
        },
        month: {
          [o]: -4,
          [c]: 4,
          [h]: -1,
          [_]: 1,
          offset: (r, T) => r.setMonth(r.getMonth() + T)
        },
        week: {
          [o]: -1,
          [c]: 1,
          [h]: -1,
          [_]: 1,
          offset: (r, T) => r.setDate(r.getDate() + T * 7)
        },
        date: {
          [o]: -7,
          [c]: 7,
          [h]: -1,
          [_]: 1,
          [q]: (r) => -r.getDay(),
          [re]: (r) => -r.getDay() + 6,
          [na]: (r) => -new Date(r.getFullYear(), r.getMonth(), 0).getDate(),
          [sa]: (r) => new Date(r.getFullYear(), r.getMonth() + 1, 0).getDate(),
          offset: (r, T) => r.setDate(r.getDate() + T)
        }
      }, S = l.value.toDate();
      for (; Math.abs(l.value.diff(S, "year", !0)) < 1; ) {
        const r = ua[Be.value];
        if (!r) return;
        if (r.offset(
          S,
          Me(r[e]) ? r[e](S) : (a = r[e]) != null ? a : 0
        ), d && d(S))
          break;
        const T = y(S).locale(v.value);
        l.value = T, F("pick", T, !0);
        break;
      }
    }, j = (e) => {
      F("panel-change", l.value.toDate(), e, s.value);
    };
    return ne(
      () => u.value,
      (e) => {
        if (["month", "year"].includes(e)) {
          s.value = e;
          return;
        } else if (e === "years") {
          s.value = "year";
          return;
        } else if (e === "months") {
          s.value = "month";
          return;
        }
        s.value = "date";
      },
      { immediate: !0 }
    ), ne(
      () => A.value,
      (e) => {
        e && (l.value = oe());
      },
      { immediate: !0 }
    ), ne(
      () => n.parsedValue,
      (e) => {
        if (e) {
          if (W.value || ue(e)) return;
          l.value = e;
        } else
          l.value = oe();
      },
      { immediate: !0 }
    ), F("set-picker-option", ["isValidValue", ta]), F("set-picker-option", ["parseUserInput", la]), F("set-picker-option", ["handleFocusPicker", oa]), (e, a) => (V(), E(
      "div",
      {
        class: i([
          t(p).b(),
          t(g).b(),
          t(p).is("border", e.border),
          t(p).is("disabled", t(w)),
          {
            "has-sidebar": e.$slots.sidebar || ye.value,
            "has-time": Y.value
          }
        ])
      },
      [
        b(
          "div",
          {
            class: i(t(p).e("body-wrapper"))
          },
          [
            K(e.$slots, "sidebar", {
              class: i(t(p).e("sidebar"))
            }),
            ye.value ? (V(), E(
              "div",
              {
                key: 0,
                class: i(t(p).e("sidebar"))
              },
              [
                (V(!0), E(
                  ma,
                  null,
                  fa(t(ce), (o, c) => (V(), E("button", {
                    key: c,
                    type: "button",
                    disabled: t(w),
                    class: i(t(p).e("shortcut")),
                    onClick: (h) => Ue(o)
                  }, U(o.text), 11, Ra))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            )) : P("v-if", !0),
            b(
              "div",
              {
                class: i(t(p).e("body"))
              },
              [
                Y.value ? (V(), E(
                  "div",
                  {
                    key: 0,
                    class: i(t(g).e("time-header"))
                  },
                  [
                    b(
                      "span",
                      {
                        class: i(t(g).e("editor-wrap"))
                      },
                      [
                        D(t(Fe), {
                          placeholder: t(C)("el.datepicker.selectDate"),
                          "model-value": Ge.value,
                          size: "small",
                          "validate-event": !1,
                          disabled: t(w),
                          readonly: !e.editable,
                          onInput: a[0] || (a[0] = (o) => M.value = o),
                          onChange: aa
                        }, null, 8, ["placeholder", "model-value", "disabled", "readonly"])
                      ],
                      2
                      /* CLASS */
                    ),
                    I((V(), E(
                      "span",
                      {
                        class: i(t(g).e("editor-wrap"))
                      },
                      [
                        D(t(Fe), {
                          placeholder: t(C)("el.datepicker.selectTime"),
                          "model-value": we.value,
                          size: "small",
                          "validate-event": !1,
                          disabled: t(w),
                          readonly: !e.editable,
                          onFocus: Qe,
                          onInput: a[1] || (a[1] = (o) => N.value = o),
                          onChange: ea
                        }, null, 8, ["placeholder", "model-value", "disabled", "readonly"]),
                        D(t(Ea), {
                          visible: O.value,
                          format: te.value,
                          "parsed-value": l.value,
                          onPick: Ze
                        }, null, 8, ["visible", "format", "parsed-value"])
                      ],
                      2
                      /* CLASS */
                    )), [
                      [t(Pa), Xe]
                    ])
                  ],
                  2
                  /* CLASS */
                )) : P("v-if", !0),
                I(b(
                  "div",
                  {
                    class: i([
                      t(g).e("header"),
                      (s.value === "year" || s.value === "month") && t(g).em("header", "bordered")
                    ])
                  },
                  [
                    b(
                      "span",
                      {
                        class: i(t(g).e("prev-btn"))
                      },
                      [
                        b("button", {
                          type: "button",
                          "aria-label": t(C)("el.datepicker.prevYear"),
                          class: i(["d-arrow-left", t(p).e("icon-btn")]),
                          disabled: t(w),
                          onClick: a[2] || (a[2] = (o) => be(!1))
                        }, [
                          K(e.$slots, "prev-year", {}, () => [
                            D(t(G), null, {
                              default: R(() => [
                                D(t(pa))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Aa),
                        I(b("button", {
                          type: "button",
                          "aria-label": t(C)("el.datepicker.prevMonth"),
                          class: i([t(p).e("icon-btn"), "arrow-left"]),
                          disabled: t(w),
                          onClick: a[3] || (a[3] = (o) => he(!1))
                        }, [
                          K(e.$slots, "prev-month", {}, () => [
                            D(t(G), null, {
                              default: R(() => [
                                D(t(ha))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ya), [
                          [B, s.value === "date"]
                        ])
                      ],
                      2
                      /* CLASS */
                    ),
                    b("span", {
                      role: "button",
                      class: i(t(g).e("header-label")),
                      "aria-live": "polite",
                      tabindex: e.disabled ? void 0 : 0,
                      "aria-disabled": e.disabled,
                      onKeydown: a[4] || (a[4] = ge((o) => H("year"), ["enter"])),
                      onClick: a[5] || (a[5] = (o) => H("year"))
                    }, U(Ke.value), 43, Oa),
                    I(b("span", {
                      role: "button",
                      "aria-live": "polite",
                      tabindex: e.disabled ? void 0 : 0,
                      "aria-disabled": e.disabled,
                      class: i([
                        t(g).e("header-label"),
                        { active: s.value === "month" }
                      ]),
                      onKeydown: a[6] || (a[6] = ge((o) => H("month"), ["enter"])),
                      onClick: a[7] || (a[7] = (o) => H("month"))
                    }, U(t(C)(`el.datepicker.month${Oe.value + 1}`)), 43, Sa), [
                      [B, s.value === "date"]
                    ]),
                    b(
                      "span",
                      {
                        class: i(t(g).e("next-btn"))
                      },
                      [
                        I(b("button", {
                          type: "button",
                          "aria-label": t(C)("el.datepicker.nextMonth"),
                          class: i([t(p).e("icon-btn"), "arrow-right"]),
                          disabled: t(w),
                          onClick: a[8] || (a[8] = (o) => he(!0))
                        }, [
                          K(e.$slots, "next-month", {}, () => [
                            D(t(G), null, {
                              default: R(() => [
                                D(t(ba))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ka), [
                          [B, s.value === "date"]
                        ]),
                        b("button", {
                          type: "button",
                          "aria-label": t(C)("el.datepicker.nextYear"),
                          class: i([t(p).e("icon-btn"), "d-arrow-right"]),
                          disabled: t(w),
                          onClick: a[9] || (a[9] = (o) => be(!0))
                        }, [
                          K(e.$slots, "next-year", {}, () => [
                            D(t(G), null, {
                              default: R(() => [
                                D(t(ya))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ua)
                      ],
                      2
                      /* CLASS */
                    )
                  ],
                  2
                  /* CLASS */
                ), [
                  [B, s.value !== "time"]
                ]),
                b(
                  "div",
                  {
                    class: i(t(p).e("content")),
                    onKeydown: ra
                  },
                  [
                    s.value === "date" ? (V(), x(Da, {
                      key: 0,
                      ref_key: "currentViewRef",
                      ref: z,
                      "selection-mode": u.value,
                      date: l.value,
                      "parsed-value": e.parsedValue,
                      "disabled-date": t(d),
                      disabled: t(w),
                      "cell-class-name": t(Q),
                      "show-week-number": e.showWeekNumber,
                      onPick: Se
                    }, null, 8, ["selection-mode", "date", "parsed-value", "disabled-date", "disabled", "cell-class-name", "show-week-number"])) : P("v-if", !0),
                    s.value === "year" ? (V(), x(ga, {
                      key: 1,
                      ref_key: "currentViewRef",
                      ref: z,
                      "selection-mode": u.value,
                      date: l.value,
                      "disabled-date": t(d),
                      disabled: t(w),
                      "parsed-value": e.parsedValue,
                      "cell-class-name": t(Q),
                      onPick: ze
                    }, null, 8, ["selection-mode", "date", "disabled-date", "disabled", "parsed-value", "cell-class-name"])) : P("v-if", !0),
                    s.value === "month" ? (V(), x(Va, {
                      key: 2,
                      ref_key: "currentViewRef",
                      ref: z,
                      "selection-mode": u.value,
                      date: l.value,
                      "parsed-value": e.parsedValue,
                      "disabled-date": t(d),
                      disabled: t(w),
                      "cell-class-name": t(Q),
                      onPick: Le
                    }, null, 8, ["selection-mode", "date", "parsed-value", "disabled-date", "disabled", "cell-class-name"])) : P("v-if", !0)
                  ],
                  34
                  /* CLASS, NEED_HYDRATION */
                )
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        ),
        e.showFooter && We.value && He.value ? (V(), E(
          "div",
          {
            key: 0,
            class: i(t(p).e("footer"))
          },
          [
            I(D(t(Te), {
              text: "",
              size: "small",
              class: i(t(p).e("link-btn")),
              disabled: qe.value,
              onClick: xe
            }, {
              default: R(() => [
                Ce(
                  U(t(C)("el.datepicker.now")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class", "disabled"]), [
              [B, !W.value && e.showNow]
            ]),
            e.showConfirm ? (V(), x(t(Te), {
              key: 0,
              plain: "",
              size: "small",
              class: i(t(p).e("link-btn")),
              disabled: Je.value,
              onClick: je
            }, {
              default: R(() => [
                Ce(
                  U(t(C)("el.datepicker.confirm")),
                  1
                  /* TEXT */
                )
              ]),
              _: 1
              /* STABLE */
            }, 8, ["class", "disabled"])) : P("v-if", !0)
          ],
          2
          /* CLASS */
        )) : P("v-if", !0)
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  dt as default
};
